/* GUMvees restyle behaviours (Oct 25 2026). Loaded from sections/gv-restyle.liquid.
   1. "Featured in" logos scroll as a ticker (the logo set is duplicated so the loop is seamless).
   2. Homepage best-seller "Add to cart" adds in place and opens the cart drawer
      (it used to send shoppers to the full /cart page). Falls back to the normal form post on any error. */
(function () {
  function ticker() {
    document.querySelectorAll('.baseline-featured-in-logos').forEach(function (box) {
      if (box.dataset.gvTicker) return;
      var logos = Array.prototype.slice.call(box.children);
      if (!logos.length) return;
      box.dataset.gvTicker = '1';
      var track = document.createElement('div');
      track.className = 'gv-fi-track';
      for (var pass = 0; pass < 2; pass++) {
        var set = document.createElement('div');
        set.className = 'gv-fi-set';
        if (pass) set.setAttribute('aria-hidden', 'true');
        logos.forEach(function (l) {
          var c = pass ? l.cloneNode(true) : l;
          var img = c.querySelector('img');
          if (img) { img.loading = 'eager'; if (pass) img.alt = ''; }
          set.appendChild(c);
        });
        track.appendChild(set);
      }
      box.appendChild(track);
      box.classList.add('gv-fi-mask');
    });
  }

  function refreshDrawer() {
    var C = window.BaselineCartDrawer;
    if (C && C.openAndRefresh) { C.openAndRefresh(); return true; }
    return false;
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form.baseline-showcase-button-form')) return;
    if (!window.fetch || !window.BaselineCartDrawer) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var fd = new FormData(f);
    fd.delete('return_to');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (!refreshDrawer()) window.location.href = '/cart';
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } f.submit(); });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ticker); else ticker();
})();
